// extracted by mini-css-extract-plugin
export var dividerContainer = "_81-0";
export var line = "_81-1";